export class ChecklistModel {
    id: number;
    name: string;
    identifier: string;
    description: string;
    targetCompletionDays: number;

    constructor(checklistModel: any) {
        if (checklistModel) {
            this.id = checklistModel.id;
            this.name = checklistModel.name;
            this.identifier = checklistModel.id;
            this.description = checklistModel.description;
            this.targetCompletionDays = checklistModel.targetCompletionDays;
        }
    }
}